import React, { useEffect, useState } from 'react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { fetchPrivacyPolicy, postPrivacyPolicy } from '../../Redux/Reducers/PrivacyReducer';
import { usePermissions } from '../../context/AuthContext';

export const PrivacyPolicy = () => {
    const { can } = usePermissions();
    const dispatch = useDispatch();
    const { content, status, error } = useSelector((state) => state.privacy || {});
    const [data, setData] = useState("");

    useEffect(() => {
        dispatch(fetchPrivacyPolicy());
    }, [dispatch]);

    useEffect(() => {
        if (content) {
            setData(content || "");
        }
    }, [content]);

    const handlePostPrivacyPolicy = (e) => {
        e.preventDefault();
        dispatch(postPrivacyPolicy({ key: "privacy_policy", title: "Privacy Policy", content: data }))
            .unwrap()
            .then(() => {
                toast.success("Privacy Policy content saved successfully!");
            })
            .catch((err) => {
                toast.error(err.message || "Failed to save Privacy Policy content.");
            });
    };

    const handleTextChange = (event, editor) => {
        const text = editor?.getData();
        setData(text);
    };

    return (
        <>
            <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                <h3 className="mb-0 fw-bold">Privacy Policy</h3>
            </div>
            <hr />
            <div className="card-body">
                <form>
                    <div className="row g-3 align-items-center">
                        <div className="col-md-12">
                            <CKEditor
                                editor={ClassicEditor}
                                data={data}
                                config={{
                                    toolbar: [
                                        "heading",
                                        "|",
                                        "bold",
                                        "italic",
                                        "link",
                                        "bulletedList",
                                        "numberedList",
                                        "|",
                                        "blockQuote",
                                        "insertTable",
                                        "|",
                                        "undo",
                                        "redo"
                                    ],
                                    placeholder: "Enter Privacy Policy content here..."
                                }}
                                onChange={handleTextChange}
                                disabled={!can('privacy_policy:edit')}
                            />
                        </div>
                    </div>
                    <br />
                    <div className="d-flex justify-content-end">
                        {can('privacy_policy:edit') && (
                            <button
                                type="submit"
                                onClick={handlePostPrivacyPolicy}
                                className="btn btn-primary btn-set-task w-sm-100 text-uppercase px-5"
                                disabled={status === 'loading'}
                            >
                                {status === 'loading' ? 'Saving...' : 'Save'}
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </>
    );
};

export default PrivacyPolicy;